import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/index";
import { TransactionalSubheader } from "iuvity-ui-components/dist/transactionalsubheader";
import { BoxFull } from "iuvity-ui-components/dist/boxfull";
import { TabView } from "iuvity-ui-components/dist/tabview";
import { Header } from "../../components";
import { FunctionalityAdminComponent } from "../../components/functionalities/FunctionalityAdminComponent";
import { useFunctionalities } from "../../hooks/useFunctionalities";

export const AdminFunctionalityPage = () => {
    const navigate = useNavigate();
    const {
        t,
        appState: { user, activeIndexCatalogue },
        setAppState,
    } = useContext(AppContext);

    const { data, functionalitiesAction, reloadFn } = useFunctionalities("DATA");
    const [activeIndex, setActiveIndex] = useState<number>(activeIndexCatalogue || 0);

    return (
        <>
            {/* <Header
                welcomeMessage={t("Dashboard.welcomeTitle")}
                userName={user?.name}
            /> */}
            <TransactionalSubheader
                subheaderTitle={
                <div
                    style={{
                        position: "relative",
                        left: "-2rem",
                    }}
                >
                    <span style={{ color: "var(--cardBackgroundColorOneShade80)" }}>{t("Functionalities.functionalitiesTitle")}</span>
                </div>
                }
            >
                <TransactionalSubheader.BreadCrumb
                id={t("Functionalities.functionalitiesTitle")}
                disabledDefaultHome={true}
                breadcrumbsHomeItem={{
                    icon: "iu iu-icon-home",
                    command: () => navigate("/"),
                }}
                breadcrumbsItems={[
                    {
                        label: t("ConsoleTranslations.adminConsoleMenuLabel"),
                        style: { fontWeight: "bold" },
                        disabled: true
                    },
                    {
                        label: t("Functionalities.functionalitiesTitle"),
                        disabled: true
                    },
                ]}
                />
                <TransactionalSubheader.Title />
            </TransactionalSubheader>

            <BoxFull className="px-5 py-0" style={{ marginTop: "40px" }} variant="tertiary">
                <div
                    className="catalogue__description"
                    style={{
                        fontFamily: "var(--fontBarlowRegular)",
                        fontSize: "var(--font-size-md)",
                        color: "var(--cardBackgroundColorOneShade80)",
                    }}
                >
                    <span>{t("Functionalities.functionalitiesDescription")}</span>
                </div>
                <TabView
                    className="upload-tabview mt-4"
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                        setActiveIndex(e.index);
                        setAppState((prev) => ({
                            ...prev,
                            activeIndexPoints: e.index,
                        }));
                    }}
                    items={[
                        {
                            key: "1",
                            header: t("Functionalities.availableTabTitle"),
                            children:
                                <FunctionalityAdminComponent
                                    data={data}
                                    functionalitiesAction={functionalitiesAction}
                                    reloadFn={reloadFn}
                                />,
                        },
                        {
                            key: "2",
                            header: t("Functionalities.deletedTabTitle"),
                            children:
                                <FunctionalityAdminComponent
                                    data={data}
                                    functionalitiesAction={functionalitiesAction}
                                    reloadFn={reloadFn}
                                    isDeleteComponent
                                />,
                        },
                    ]}
                />
            </BoxFull>
        </>
    )
}